<template>
    <b-container >
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row class="justify-content-md-center">
                <b-col md="12" sm="12" class="mt-2">
                    <p class="reg-heading-tab">Decleration Details</p>
                    <p></p>
                    <div class="reg-tab-container">

                          <div class="declaration-wrap">
                              <h2>लाभार्थ्याचे शपथ पत्र </h2>
                              <h5>राजे उमाजी नाई‍क आर्थिक विकास महामंडळ </h5>
                              <!-- <h6>उपकंपनी - शामराव पेजे कोकण इतर मागासवर्ग आर्थिक विकास महामंडळ  </h6> -->
                              
                              <p>1.मी श्री {{this.userDetails.applicantName}}<br>
पत्ता:at post {{this.applicantCity}} <br>
आज {{this.userDetails.date}} रोजी शपथपूर्वक ‍लिहून देत आहे की,
</p>

<p>2. माझा आधार क्रमांक {{this.userDetails.adharNo}} हा आहे.</p>
<p>3. मी अर्ज करतेवेळी या प्रकल्पासाठी व यापूर्वी या महामंडळाच्या तसेच इतर महामंडळाच्या कोणत्याही योजनांचा लाभ घेतलेला नाही.</p>
<p>4. सदर कर्ज प्रकरणामध्ये जोडलेली सर्व कागदपत्रे व माहिती सत्य असून त्यामध्ये कोणत्याही प्रकारची माहिती किंवा कागदपत्रे खोटे आढळल्यास शासनाच्या नियमानुसार होणाऱ्या कायदेशीर कार्यवाहीसाठी मी स्वत: पात्र/ जबाबदार असेन, याची मला पूर्ण जाणीव आहे.</p>
                          </div> <!-- declaration-wrap ends -->    


                            <b-form-checkbox id="checkbox1" plain 
                                            v-model="form.UserDecleration.ConfirmStatus"
                                            style="font-size: 0.875rem;"
                                            >
                                     I Agree the terms and Conditions
                            </b-form-checkbox>
                    </div>
                </b-col>
            </b-row>
             <b-row class="mt-2 justify-content-md-center" v-if="!userDetails.LockProfile">
                <b-col style="text-align:center">
                  <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                  <b-alert :show = "showDismissibleAlert" dismissible 
                      @dismissed="showDismissibleAlert=false"
                      
                      :variant="variant">
                      {{alertText}}
                  </b-alert>
                </b-col>
                <b-col style="text-align:right" class="button-wrap">
                  <b-button type="submit" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                  <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
export default {
  components: { Spinner },
  data() {
    return {
      applicantName: "--",
      applicantAge: 0,
      
      form: {
        UserDecleration: { ConfirmStatus: true },
        LoginID: "",
        LoanApplication:[{
          LoanType:"",
          UserID:""
        }]
      },
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved:false,
    };
  },
  computed: {
    userDetails() {
      let userinfo = this.$store.getters.getUserData;

      if (userinfo) {
        let age = this.calculateAge(userinfo.DOB);
        let today = new Date();
        let date = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear();
        return {
          applicantName:
            userinfo.FirstName +
            " " +
            userinfo.MiddleName +
            " " +
            userinfo.LastName,
          age : age,
          LockProfile:userinfo.LockProfile,
          date:date,
          adharNo:userinfo.AdharNo
        };
      } else{
        return{
          applicantName:"--",
          age:"--",
          LockProfile:false
        }
      }
    },
    applicantCity(){
      return this.$store.getters.getLocation;
    },
    isLoggedIn() {
      if (this.$store.getters.isLoggedIn) {
        this.disabled = false;
        // alert(this.disabled);
      }
      return this.$store.getters.isLoggedIn;
    },
    getScheme() {
      let x = this.$store.getters.getScheme;
      //console.log (x);
      return x;
    }
  },
  methods: {
    onClickButton() {
      this.saved=false;
      this.showDismissibleAlert=false;
      this.$emit('clicked');
    },
    calculateAge(birthDate) {
      birthDate = new Date(birthDate);
      let otherDate = new Date();

      var years = otherDate.getFullYear() - birthDate.getFullYear();

      if (
        otherDate.getMonth() < birthDate.getMonth() ||
        (otherDate.getMonth() == birthDate.getMonth() &&
          otherDate.getDate() < birthDate.getDate())
      ) {
        years--;
      }

      return years;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      this.form.LoanApplication[0].LoanType = this.$store.getters.getScheme.LoanType;
      this.form.LoanApplication[0].UserID = userinfo.UserId;
      let promise = apis.saveUserDeclaration(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset(evt) {}
  },
  mounted() {
    // var userinfo = this.$store.getters.loggedUser;
    // this.applicantName = userinfo.UserName;
    // let promise = apis.ReadUserDecleration(userinfo.UserId);

    // promise
    //   .then(response => {
    //     if (response.status == 200) {
    //       this.form.UserDecleration = response.body;
    //       this.isLoading = false;
    //     } else {
    //       this.alertText = response.body;

    //       this.variant = "warning";
    //       this.showDismissibleAlert = true;
    //     }
    //   })
    //   .catch(err => {
    //     this.alertText = err.message;
    //     this.showDismissibleAlert = true;
    //     this.variant = "danger";
    //   });
  }
};
</script>

<style>

.declaration-wrap,
.declaration-wrap p,
.declaration-wrap h2,
.declaration-wrap h4{
      font-family: 'Laila', serif;
      color:#000;
}

.declaration-wrap h2{
  font-size: 24px;
}

.declaration-wrap h4{
  font-size:19px;
  margin-top:15px;
  margin-bottom:15px;
}
.declaration-wrap p{
  margin-top:10px;
  margin-bottom:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/Declaration.vue